import { ColDef } from "@ag-grid-community/core";

export const PublicationColumnDefinitions: ColDef[] = [
    {
        field: "title",
        wrapText: true,
        sortable: true,
        suppressMovable: true,
        width: 300,
        cellStyle: {
            padding: "10px"
        }
    },
    {
        field: "name",
        wrapText: true,
        sortable: true,
        suppressMovable: true,
        width: 300,
        cellStyle: {
            padding: "10px"
        }
    },
    {
        field: "doi",
        wrapText: true,
        sortable: true,
        suppressMovable: true,
        width: 300,
        cellStyle: {
            padding: "10px"
        }
    },
    {
        field: "purpose",
        wrapText: true,
        sortable: true,
        suppressMovable: true,
        width: 300,
        cellStyle: {
            padding: "10px"
        }
    },
    {
        field: "method",
        wrapText: true,
        sortable: true,
        suppressMovable: true,
        width: 300,
        cellStyle: {
            padding: "10px"
        }
    },
    {
        field: "results",
        wrapText: true,
        sortable: true,
        suppressMovable: true,
        width: 300,
        cellStyle: {
            padding: "10px"
        }
    },
    {
        field: "conclusion",
        wrapText: true,
        sortable: true,
        suppressMovable: true,
        width: 300,
        cellStyle: {
            padding: "10px"
        }
    },
    {
        field: "datePublished",
        wrapText: true,
        sortable: true,
        suppressMovable: true,
        width: 300,
        cellStyle: {
            padding: "10px"
        }
    },
    {
        field: "author",
        wrapText: true,
        sortable: true,
        suppressMovable: true,
        width: 300,
        cellStyle: {
            padding: "10px"
        }
    },
    {
        field: "pages",
        wrapText: true,
        sortable: true,
        suppressMovable: true,
        width: 300,
        cellStyle: {
            padding: "10px"
        }
    },
    {
        field: "keywords",
        wrapText: true,
        sortable: true,
        suppressMovable: true,
        width: 300,
        cellStyle: {
            padding: "10px"
        }
    },
    {
        field: "study",
        wrapText: true,
        sortable: true,
        suppressMovable: true,
        width: 300,
        cellStyle: {
            padding: "10px"
        }
    },
    {
        headerName: "ABCD Release Version",
        field: "additionalFields",
        wrapText: true,
        sortable: true,
        suppressMovable: true,
        width: 300,
        cellRenderer: function (params: any) {
            const additionalFields = params.value;
            if (additionalFields) {
                try {
                    const parsedFields = JSON.parse(additionalFields);
                    return parsedFields.abcdReleaseVersion || '';
                } catch (e) {
                    console.error('Error parsing additionalFields:', e);
                    return '';
                }
            }
            return '';
        },
        cellStyle: { padding: "10px" },
    },
    {
        headerName: "ABCD Domains",
        field: "additionalFields",
        wrapText: true,
        sortable: true,
        suppressMovable: true,
        width: 300,
        cellRenderer: function (params: any) {
            const additionalFields = params.value;
            if (additionalFields) {
                try {
                    const parsedFields = JSON.parse(additionalFields);
                    return parsedFields.abcdDomains || '';
                } catch (e) {
                    console.error('Error parsing additionalFields:', e);
                    return '';
                }
            }
            return '';
        },
        cellStyle: { padding: "10px" },
    },
    {
        headerName: "HBCD Release Version",
        field: "additionalFields",
        wrapText: true,
        sortable: true,
        suppressMovable: true,
        width: 300,
        cellRenderer: function (params: any) {
            const additionalFields = params.value;
            if (additionalFields) {
                try {
                    const parsedFields = JSON.parse(additionalFields);
                    return parsedFields.hbcdReleaseVersion || '';
                } catch (e) {
                    console.error('Error parsing additionalFields:', e);
                    return '';
                }
            }
            return '';
        },
        cellStyle: { padding: "10px" },
    },
    {
        headerName: "HBCD Domains",
        field: "additionalFields",
        wrapText: true,
        sortable: true,
        suppressMovable: true,
        width: 300,
        cellRenderer: function (params: any) {
            const additionalFields = params.value;
            if (additionalFields) {
                try {
                    const parsedFields = JSON.parse(additionalFields);
                    return parsedFields.hbcdDomains || '';
                } catch (e) {
                    console.error('Error parsing additionalFields:', e);
                    return '';
                }
            }
            return '';
        },
        cellStyle: { padding: "10px" },
    }
]